import { useEffect, useState } from "react";

import { updateSMSSettings } from "../../services/settingsApi";

function SMSSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        provider: "",
        apiKey: "",
        senderId: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                provider: settings.provider || "",
                apiKey: settings.apiKey || "",
                senderId: settings.senderId || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateSMSSettings(formData);

            alert("SMS settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update SMS settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>SMS Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>SMS Provider</label>

                        <input
                            type="text"
                            name="provider"
                            value={formData.provider}
                            onChange={handleChange}
                            placeholder="MSG91 / Twilio / Fast2SMS"
                        />

                    </div>

                    <div className="form-group">

                        <label>API Key</label>

                        <input
                            type="password"
                            name="apiKey"
                            value={formData.apiKey}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Sender ID</label>

                        <input
                            type="text"
                            name="senderId"
                            value={formData.senderId}
                            onChange={handleChange}
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save SMS Settings
                </button>

            </div>

        </form>

    );

}

export default SMSSettings;